module.exports = __webpack_public_path__ + "static/media/Apple MacBook Air 13\" Silver.0686914a.png";